module.exports = __webpack_public_path__ + "img/postgresql.1a804955.svg";